export default {
  SET_MATERIAL_RECOMMENDATIONS(state: any, recommendations: any) {
    state.recommendedBoards = recommendations.recommendedBoardOfList.nodes;
    state.recommendedBoardSections =
      recommendations.recommendedBoardSectionOfList.nodes;
  },
  SET_QUESTION_ID_LIST_SLUG_INDEX(
    state: any,
    {
      listSlug,
      index,
      questionId,
    }: { listSlug: string; index: number; questionId: number },
  ) {
    state.idOfQuestionBySlugAndIndex = {
      ...state.idOfQuestionBySlugAndIndex,
      [listSlug]: {
        ...state.idOfQuestionBySlugAndIndex[listSlug],
        [index]: questionId,
      },
    };
  },
  SET_LIST_PERFORMANCE_USER_REPLIES(
    state: any,
    { listId, listPerformance }: { listId: number; listPerformance: object },
  ) {
    state.listPerformance = {
      ...state.listPerformance,
      [listId]: listPerformance,
    };
  },
  SET_EXAM_RESULTS(state: any, examResults: any) {
    state.examResults = examResults;
  },
};
